<template lang="html">
  <div>
    <v-card flat>
      <v-card-title class="secondary white--text">
        <div class="ma-0">
          <div class="d-flex align-center">
            <v-icon large left color="white">mdi-home</v-icon>
            <p class="subtitle-1 my-0">{{ tableData && tableData.Count ? tableData.Count : 0 }} Properties</p>
          </div>
        </div>
        <v-spacer></v-spacer>
        <generic-search
          v-model="propertyId"
          label="Search Property"
          schema-type="PropertyOwnable"
          :hide-details="true"
          :dark="true"
          @change="handleFilterChange"
        />
      </v-card-title>

      <!-- Table -->
      <v-data-table
        :headers="tableHeaders"
        :items="tableData && tableData.Data ? tableData.Data : []"
        :loading="isLoading"
        :search="search"
        :server-items-length="tableData && tableData.Count ? tableData.Count : 0"
        :options.sync="options"
        :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
        @update:options="handleOptionsUpdate"
        class="elevation-0"
        no-data-text="No properties found"
        :items-per-page="10"
      >
        <template v-slot:item.property="{ item }">
          <div>
            <p class="my-0 font-weight-light">{{ item.Landlord }}</p>
            <p class="my-0">{{ item.PropertyAddress }}</p>
          </div>
        </template>

        <template v-slot:item.RentPerCalendarMonth="{ item }">
          <span class="font-weight-light text-caption">{{ item.RentPerCalendarMonth }}</span>
        </template>

        <template v-slot:item.ServiceType="{ item }">
          <span class="font-weight-light text-caption">{{ item.ServiceType }}</span>
        </template>

        <template v-slot:item.TenancyState="{ item }">
          <span class="font-weight-light text-caption">{{ item.TenancyState }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="secondary"
                dark
                small
                depressed
                v-bind="attrs"
                v-on="on"
                class="text-capitalize"
              >
                Actions
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list class="py-0 secondary" dark>
              <v-list-item @click="openDialog(item)">
                <v-list-item-title>Contact support regarding this property</v-list-item-title>
                <v-list-item-icon>
                  <v-icon small>mdi-comment-text-outline</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <MsgDialog
      :dialog="dialog"
      :details="selectedItem.PropertyAddress"
      :source="source"
      :OID="selectedItem.TenancyID"
      @closeDialog="closeDialog"
      @msgSent="msgSent"
    />

    <Snackbar 
      :snackbarDialog="snackbar" 
      :snackbarText="snackbarText" 
      :snackbarColor="snackbarColor"
      @closeSnackbar="closeSnackbar()"
      :timeout="timeout"
    />

  </div>
</template>

<script>
import MsgDialog from '@/components/Dialogs/MessageDialog'
import Snackbar from '@/components/Snackbars/TheSnackbar'
import GenericSearch from '@/components/CloudSearch/GenericSearch.vue'

export default {
  components: {
    MsgDialog,
    Snackbar,
    GenericSearch
  },
  props: ['tableData', 'headers', 'msg', 'isLoading'],
  data() {
    return {
      source: 'Properties',
      search: '',
      selectedItem: '',
      dialog: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: '',
      timeout: 3000,
      options: {
        page: 1,
        itemsPerPage: 10
      },
      tableHeaders: [
        { text: 'Property', value: 'property', sortable: false },
        { text: 'Rent PCM', value: 'RentPerCalendarMonth', sortable: false },
        { text: 'Service Type', value: 'ServiceType', sortable: false },
        { text: 'State', value: 'TenancyState', sortable: false },
        { text: 'Actions', value: 'actions', align: 'end', sortable: false }
      ],
      // Filter data
      propertyId: ''
    }
  },
  computed: {
    hasActiveFilters() {
      return this.propertyId
    }
  },
  methods: {
    closeSnackbar() {
      this.snackbar = false
    },
    openDialog(item) {
      this.selectedItem = item
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.selectedItem = ''
    },
    msgSent(payload) {
      this.dialog = false
      this.snackbar = true,
      this.snackbarColor = payload.color
      this.snackbarText = payload.text
    },
    handleOptionsUpdate(newOptions) {
      if (this.search || this.isLoading) return // Don't emit for client-side search or while loading
      
      let type = 'managed';
      if (this.msg.includes('ownerless')) type = 'ownerless';
      else if (this.msg.includes('rent collected')) type = 'rentCollected';
      else if (this.msg.includes('without tenants')) type = 'tenantless';
      else if (this.msg.includes('not managed')) type = 'notManaged';
      else if (this.msg.includes('new tenancies')) type = 'newTenancies';
      else if (this.msg.includes('historic')) type = 'historic';
      
      this.$emit('paginate', type, newOptions.page, newOptions.itemsPerPage, { propertyId: this.propertyId });
    },
    handleFilterChange() {
      // Reset to first page when filters change
      this.options.page = 1;
      this.handleOptionsUpdate(this.options);
    },
    clearAllFilters() {
      this.propertyId = '';
      this.handleFilterChange();
    }
  }
}
</script>

<style lang="css" scoped>
</style>